export const TICK_GAP = 170;
export const HIGHLIGHT_WIDGET_GRID_TEMPLATE = "minmax(240px,400px) minmax(280px,1fr)";
